export const mockData = [
  {
    key: "price",
    type: "Price",
    "01.01.2025": "$34.99",
    "02.01.2025": "$34.99",
    "03.01.2025": "$34.99",
    "04.01.2025": "$27.99",
    "05.01.2025": "$27.99",
    "06.01.2025": "$24.99",
    "07.01.2025": "$24.99",
    "08.01.2025": "$24.99",
  },
  {
    key: "discount",
    type: "Discount",
    "01.01.2025": "0%",
    "02.01.2025": "0%",
    "03.01.2025": "0%",
    "04.01.2025": "5%",
    "05.01.2025": "5%",
    "06.01.2025": "10%",
    "07.01.2025": "10%",
    "08.01.2025": "10%",
  },
  {
    key: "coupon",
    type: "Coupon",
    "01.01.2025": "0%",
    "02.01.2025": "0%",
    "03.01.2025": "0%",
    "04.01.2025": "5%",
    "05.01.2025": "5%",
    "06.01.2025": "10%",
    "07.01.2025": "10%",
    "08.01.2025": "10%",
  },
];

export const chartData = [
  { name: "Jun", blue: 100, red: 200 },
  { name: "Jul", blue: 100, red: 190 },
  { name: "Aug", blue: 100, red: 185 },
  { name: "Sep", blue: 105, red: 190 },
  { name: "Oct", blue: 105, red: 195 },
  { name: "Nov", blue: 110, red: 195 },
  { name: "Dec", blue: 115, red: 195 },
  { name: "Jan", blue: 120, red: 195 },
  { name: "Feb", blue: 115, red: 200 },
  { name: "Mar", blue: 115, red: 205 },
  { name: "Apr", blue: 120, red: 210 },
  { name: "May", blue: 130, red: 220 },
  { name: "Jun", blue: 140, red: 230 },
  { name: "Jul", blue: 140, red: 230 },
  { name: "Aug", blue: 130, red: 225 },
];
